import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import anime from 'animejs';

const SVG = styled.svg`
  overflow: visible;
  & * {
    transform-box: fill-box;
  }
`;

interface BellIconProps extends React.HTMLAttributes<SVGElement> {
  size?: number;
  x?: number;
  y?: number;
  strokeWidth?: number;
}

function BellIcon({ size = 66, strokeWidth = 3, ...props }: BellIconProps) {
  const ref = useRef(null);

  useEffect(() => {
    const timeline = anime.timeline({
      autoplay: true,
      loop: false,
    });

    const ball = ref.current.querySelector('.bellBall');

    timeline.add({
      targets: ref.current,
      rotate: [0, 45],
      easing: 'easeInOutQuint',
      duration: 200,
    });

    timeline.add(
      {
        targets: ball,
        rotate: [0, -15],
        easing: 'easeInOutQuint',
        duration: 200,
      },
      '-=200'
    );

    timeline.add({
      targets: ref.current,
      rotate: 0,
      easing: 'easeOutElastic(1.5, 0.2)',
      duration: 1500,
    });

    timeline.add(
      {
        targets: ball,
        rotate: 0,
        easing: 'easeOutElastic(3, 0.1)',
        duration: 2000,
      },
      '-=1500'
    );
  }, []);

  return (
    <SVG width={size} height={size} viewBox={`0 0 66 66`} {...props}>
      <g
        fill="none"
        stroke="black"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(7,0)"
      >
        <g style={{ transformOrigin: 'top center' }} ref={ref} className="bell">
          <path
            className="bellBody"
            d="M19.7333 9.44475C19.7333 4.84254 22.5333 2 26.9333 2C30.4533 2 33.3333 5.24862 33.3333 9.44475C38.5333 11.7459 42.9333 16.7541 42.9333 26.2293C42.9333 36.5166 47.6444 47.0295 50 51H26.9333H2C5.2 47.7514 9.73333 35.7044 9.73333 26.2293C9.73333 16.7541 14.4 12.1519 19.7333 9.44475Z"
          />
          <path
            className="bellBall"
            d="M19 60C20.8172 65.1921 30.3226 65.4727 32 60"
            style={{ transformOrigin: '50% -60px' }}
          />
        </g>
      </g>
    </SVG>
  );
}

export default BellIcon;
